import type { BlockedInstructions, DraggableRowProps } from './types.tsx';

export const getBlockedInstructions = ({
	dropTarget,
	draggedItem,
	isGrouping,
	isRowReorderingEnabled,
}: {
	dropTarget?: DraggableRowProps;
	draggedItem?: Record<string, unknown>;
	isGrouping?: Boolean;
	isRowReorderingEnabled: Boolean;
}): BlockedInstructions => {
	// We don't support reordering and reparenting
	if (isRowReorderingEnabled) {
		return ['make-child'];
	}

	const draggedItemLevel = draggedItem?.hierarchyLevel;
	const dropTargetLevel = dropTarget?.hierarchyLevel;

	const dragItemParentIsDropTarget =
		String(dropTarget?.issueId) === String(draggedItem?.parentIssueAri);

	const shouldBlockInstructions =
		dragItemParentIsDropTarget ||
		isGrouping ||
		// cannot reparenting to another level, from example reparenting a task into another task like a subtask
		(typeof draggedItemLevel === 'number' && dropTargetLevel !== draggedItemLevel + 1);

	if (shouldBlockInstructions) {
		return ['make-child', 'reorder-below', 'reorder-above'];
	}

	// TODO: Implement unparent
	if (dropTargetLevel === 0) {
		return ['reorder-below', 'reorder-above'];
	}

	return [];
};
